import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { DatePicker } from 'antd';
import Select, { StylesConfig } from "react-select";
import { TimePicker, TimePickerProps } from "antd";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs, { Dayjs } from "dayjs";
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import TextField from '../../../../core/common/textFields/TextField';
import { customStyles } from '../../../../core/common/Custom Style/CustomStyle';
import { useCreateAppointmentMutation, useGetProjectLookupsQuery } from '../../../../services/EndPointsApis';

const SourceContactWizard = ({ formik, getdefaultLookups,projectLookups }: any) => {
    dayjs.extend(customParseFormat);

    const onChangeStart: TimePickerProps['onChange'] = (time, timeString) => {
        const formattedTime = time ? dayjs(time).format("h:mm A") : '';
        formik.setFieldValue('startTime', formattedTime);
    };

    const handleSourceDateChange = (date: Dayjs | null) => {
        formik?.setFieldValue('firstContactDate', date ? date.format('YYYY-MM-DD') : null);
    };

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row">
                <h5 className='text-gray mb-3'>Contact/Lead Source</h5>
                <div className="col-md-6 mt-2">
                    <label className="input-label">
                        1st Contact Date <span className="text-danger">*</span>
                    </label>
                    <div className="form-wrap icon-form">
                        <span className="form-icon">
                            <i className="ti ti-calendar-check" />
                        </span>
                        <DatePicker
                            className="form-control datetimepicker deals-details"
                            onChange={handleSourceDateChange}
                            value={formik?.values?.firstContactDate ? dayjs(formik?.values?.firstContactDate, 'YYYY-MM-DD') : null}
                            format="MMM-DD-YYYY"
                        />
                    </div>
                </div>
                <div className="col-md-6 mt-2">
                    <label className="input-label">
                        Inquiry Method <span className="text-danger"> *</span>
                    </label>
                    <Select
                        styles={customStyles}
                        className="select"
                        options={getdefaultLookups?.result?.
                            Lst_MethodOfInquiry?.map((option: any) => ({
                                label: option?.value,
                                value: option?.id
                            }))}
                        value={
                            formik.values?.lst_MethodOfInquiry?.id
                                ? {
                                    value: formik.values?.lst_MethodOfInquiry?.id,
                                    label: formik.values?.lst_MethodOfInquiry?.value || '',
                                }
                                : null
                        }
                        // isDisabled={isReadOnly}
                        onChange={(selectedOption: any) => {
                            formik.setFieldValue('lst_MethodOfInquiry.id', selectedOption.value);
                            formik.setFieldValue('lst_MethodOfInquiry.value', selectedOption.label);
                        }}
                    />
                </div>
                <div className="col-md-6 mt-2">
                    <label className="input-label">
                        Lead Source Category
                    </label>
                    <Select
                        styles={customStyles}
                        className="select"
                        options={projectLookups?.result?.
                            Lst_LeadSourceCategory?.map((option: any) => ({
                                label: option?.value,
                                value: option?.id
                            }))}
                        value={
                            formik.values?.lst_LeadSourceCategory?.id
                                ? {
                                    value: formik.values?.lst_LeadSourceCategory?.id,
                                    label: formik.values?.lst_LeadSourceCategory?.value || '',
                                }
                                : null
                        }
                        // isDisabled={isReadOnly}
                        onChange={(selectedOption: any) => {
                            formik.setFieldValue('lst_LeadSourceCategory.id', selectedOption.value);
                            formik.setFieldValue('lst_LeadSourceCategory.value', selectedOption.label);
                        }}
                    />
                </div>
                <div className="col-md-6 mt-2">
                    <label className="input-label">
                        Lead Source <span className="text-danger"> *</span>
                    </label>
                    <Select
                        styles={customStyles}
                        className="select"
                        options={projectLookups?.result?.
                            Lst_LeadSource?.map((option: any) => ({
                                label: option?.value,
                                value: option?.id
                            }))}
                        value={
                            formik.values?.lst_LeadSource?.id
                                ? {
                                    value: formik.values?.lst_LeadSource?.id,
                                    label: formik.values?.lst_LeadSource?.value || '',
                                }
                                : null
                        }
                        // isDisabled={isReadOnly}
                        onChange={(selectedOption: any) => {
                            formik.setFieldValue('lst_LeadSource.id', selectedOption.value);
                            formik.setFieldValue('lst_LeadSource.value', selectedOption.label);
                        }}
                    />
                </div>
                <div className='col-md-12'>
                    <label className='input-label'>Source Description</label>
                    <textarea
                        rows={3}
                        className='form-control'
                        {...formik.getFieldProps('sourceDescription')}
                    />
                </div>
                <div className='col-md-12'>
                    <TextField
                        label="Ad Code "
                        type="text"
                        {...formik.getFieldProps("adCode")}
                    />
                </div>

            </div>
        </form>
    )
}

export default SourceContactWizard